import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { forwardRef, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export type RadioOption = {
  value: string;
  label: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
};

export type RadioProps = RadioGroupPrimitive.RadioGroupProps & {
  options: RadioOption[];
  error?: boolean;
};

export const Radio = forwardRef<HTMLDivElement, RadioProps>(({ className, options, error, ...props }, ref) => (
  <RadioGroupPrimitive.Root ref={ref} className={cn("bfrs-grid bfrs-gap-2", className)} aria-invalid={error} {...props}>
    {options.map((option) => (
      <label key={option.value} className={cn("bfrs-inline-flex bfrs-items-start bfrs-gap-3 bfrs-text-sm bfrs-text-text-primary", option.disabled ? "bfrs-text-text-disabled" : "bfrs-cursor-pointer")}>
        <RadioGroupPrimitive.Item
          value={option.value}
          disabled={option.disabled}
          className={cn(
            "bfrs-mt-0.5 bfrs-size-5 bfrs-shrink-0 bfrs-rounded-pill bfrs-border bfrs-bg-surface-card bfrs-outline-none bfrs-transition focus-visible:bfrs-ring-2 focus-visible:bfrs-ring-border-focus/25 disabled:bfrs-cursor-not-allowed disabled:bfrs-opacity-50 data-[state=checked]:bfrs-border-primary",
            error ? "bfrs-border-danger" : "bfrs-border-border-control"
          )}
        >
          <RadioGroupPrimitive.Indicator className="bfrs-flex bfrs-size-full bfrs-items-center bfrs-justify-center after:bfrs-size-2.5 after:bfrs-rounded-pill after:bfrs-bg-primary after:bfrs-content-['']" />
        </RadioGroupPrimitive.Item>
        <span className="bfrs-grid bfrs-gap-0.5">
          <span className={cn("bfrs-font-medium", option.disabled ? "bfrs-text-text-disabled" : "bfrs-text-text-primary")}>{option.label}</span>
          {option.description && <span className={cn("bfrs-text-xs bfrs-leading-5", option.disabled ? "bfrs-text-text-disabled" : "bfrs-text-text-muted")}>{option.description}</span>}
        </span>
      </label>
    ))}
  </RadioGroupPrimitive.Root>
));

Radio.displayName = "Radio";
